export default function StatusBadge({ status, children, testId, ...rest }) {
    const cls =
        status === "completed" ? "status-completed"
        : status === "critical" || status === "action_required" || status === "action" ? "status-action"
        : status === "low" ? "status-low"
        : "status-pending";
    return (
        <span
            data-testid={testId || rest["data-testid"]}
            className={`${cls} inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide`}
        >
            {children}
        </span>
    );
}
